import { post } from '~/plugins/nikan-api'
import Endpoints from '@nikan/endpoints'
import _ from 'lodash'


export const state = {
  items: [],
  fetched: false
}

export const mutations = {
  set(state, items) {
    state.items = [].concat(items)
    state.fetched = true
  },
}

export const actions = {
  async refresh({ state, commit }, options) {
    options = _.merge({ force: false }, options)
    if (options.force || !state.fetched) {
      await post(Endpoints.getUrl('productClassification.list'))
        .then(data => {
          commit('set', data.data.items)
        })
    }
  }
}

export const getters = {
  all: state => {
    return state.items
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
